import React from "react"
import { Toast as ToastPrime } from "primereact/toast"

/** @type {import("./Toast.atom")["default"]} */
const Toast = React.forwardRef((props, ref) => {
  return <ToastPrime {...props} ref={ref} />
})

export default Toast
